export type MusicSection = "VERSE" | "HOOK";

function clampLevel(level: number): number {
  return Math.max(1, Math.min(20, Math.floor(level)));
}

function levelId(level: number): string {
  return String(clampLevel(level)).padStart(2, "0");
}

export function resolveLevelVerseCandidates(level: number): string[] {
  const id = levelId(level);
  return [`/assets/music/level${id}_verse.ogg`];
}

export function resolveLevelHookCandidates(level: number): string[] {
  const id = levelId(level);
  return [
    `/assets/music/level${id}_hook.ogg`,
    `/assets/music/level${id}_chorus.ogg`
  ];
}

export function bpmForLevel(level: number): number {
  const clamped = clampLevel(level);
  return Math.min(180, 85 + (clamped - 1) * 5);
}
